import {createFileRoute} from '@tanstack/react-router';

import ResetPassword from '@/anonymous/views/ResetPassword';

export const Route = createFileRoute('/(anonymous)/reset-password')({
  component: ResetPassword
});
